import type { BasePagingResponse, BaseResponse } from "../../../lib/api-contract";
import { apiUtils } from "../../../utils/apiUtils";
import type {
  GetMerchantListRequest,
  MerchantDetail,
  MerchantListItem,
  MerchantStatistics,
  SuspendMerchantRequest,
  UpdateMerchantAdminRequest,
} from "../types/merchant.types";

const MERCHANT_BASE_PATH = "/v1/portal/merchant";

export async function getMerchantList(
  request: GetMerchantListRequest,
  signal?: AbortSignal,
): Promise<BasePagingResponse<MerchantListItem>> {
  return apiUtils.getData<BasePagingResponse<MerchantListItem>>(
    MERCHANT_BASE_PATH,
    "Failed to fetch merchant list",
    {
      params: request,
      paramsSerializer: { indexes: null },
      signal,
    },
  );
}

export function getMerchantStatistics(signal?: AbortSignal): Promise<MerchantStatistics> {
  return apiUtils.getData<MerchantStatistics>(
    `${MERCHANT_BASE_PATH}/statistic`,
    "Failed to fetch merchant statistics",
    { signal },
  );
}

export function getMerchantDetail(id: string, signal?: AbortSignal): Promise<MerchantDetail> {
  return apiUtils.getData<MerchantDetail>(
    `${MERCHANT_BASE_PATH}/${id}`,
    "Failed to fetch merchant detail",
    { signal },
  );
}

export async function updateMerchant(
  id: string,
  request: UpdateMerchantAdminRequest,
  signal?: AbortSignal,
): Promise<MerchantDetail> {
  return apiUtils.putData<MerchantDetail, UpdateMerchantAdminRequest>(
    `${MERCHANT_BASE_PATH}/${id}`,
    request,
    "Failed to update merchant",
    { signal },
  );
}

export async function approveMerchant(id: string, signal?: AbortSignal): Promise<MerchantDetail> {
  return apiUtils.postData<MerchantDetail, Record<string, never>>(
    `${MERCHANT_BASE_PATH}/${id}/approve`,
    {},
    "Failed to approve merchant",
    { signal },
  );
}

export async function suspendMerchant(
  id: string,
  request: SuspendMerchantRequest,
  signal?: AbortSignal,
): Promise<MerchantDetail> {
  return apiUtils.postData<MerchantDetail, SuspendMerchantRequest>(
    `${MERCHANT_BASE_PATH}/${id}/suspend`,
    request,
    "Failed to suspend merchant",
    { signal },
  );
}

export function deleteMerchant(
  id: string,
  signal?: AbortSignal,
): Promise<BaseResponse<object | null>> {
  return apiUtils.delete<object | null>(`${MERCHANT_BASE_PATH}/${id}`, { signal });
}
